(function() {
    // See grid layout IH-Modal-Dialog.html for info on set up.

	class Dialog {
		constructor(element) {
			this.dialog = element;
            this.dialogWrapper = element.parentElement;
			this.id = this.dialogWrapper.classList.value;
			this.closeButtons = this.dialog.querySelectorAll('[modal-dialog-close]');
            this.openButton = document.querySelector(`a[href="#${this.id}"][modal="true"]`);
			this.events();
		}
		events() {
			this.closeButtons.forEach((button) => {
				button.addEventListener('click', this.closeDialog.bind(this));
			});
			this.openButton?.addEventListener('click', this.openDialog.bind(this));
			this.dialog.addEventListener('close', this.onClose.bind(this));
		}
		onClose() {
			document.body.classList.remove('modal-open');
		}
		openDialog() {
			this.dialog.showModal();
			document.body.classList.add('modal-open');
		}
		closeDialog() {
			this.dialog.close();
			document.body.classList.remove('modal-open');
		}
	}
	const dialogs = document.querySelectorAll("[modal-dialog]");
	dialogs.forEach((dialog) => {
		new Dialog(dialog);
	});

})();